import { UPDATE_PAGE_TEMPLATE_NAME } from '../actions';
import { UPDATE_PAGE_TEMPLATE_USER_LABEL } from '../actions';

export default function (state = {}, action) {
  switch (action.type) {
  case UPDATE_PAGE_TEMPLATE_NAME: {
    const templates = [...state].map(template => ({
      ...template,
      name: template.id == action.payload.id 
        ? action.payload.name
        : template.name
    }));

    return templates;
  }
  case UPDATE_PAGE_TEMPLATE_USER_LABEL: {
    const templates = [...state].map(template => ({
      ...template,
      user_label: template.id == action.payload.id 
        ? action.payload.userLabel 
        : template.user_label
    }));

    return templates;
  }
  default:
    return state;
  }
}
